import createActionTypes from './createActionTypes';

export const namespace = 'VIEWER';

export const types = createActionTypes(namespace, [
  'INITIALIZE',
  'INITIALIZE_SA',
  'WINDOW_RESIZE_CHANGED_PAGES',
  'BROWSE',
  'ENRICHMENT',
  'EXIT',
  'UPDATE',
  'UPDATED',
  'NAVIGATOR_OPEN',
  'ZOOMED',
  'TAP',
  'SET_CURRENT_FLYER_PAGES',
  'FETCH_FLYER_PAGES',
  'SET_DIRECTION',
  'INDEX_BUTTON_CLICK',
  'SECTION_CLICK',
  'SET_VIEWER_EXTRAS_BASE',
]);

export const initialize = (event) => ({
  type: types.INITIALIZE,
  payload: event,
});

export const windowResizeChangedPages = (event) => ({
  type: types.WINDOW_RESIZE_CHANGED_PAGES,
  payload: event,
});

export const browse = (event) => ({
  type: types.BROWSE,
  payload: event,
});

export const enrichment = (event) => ({
  type: types.ENRICHMENT,
  payload: event,
});

export const exit = (event) => ({
  type: types.EXIT,
  payload: event,
});

export const update = (payload) => ({
  type: types.UPDATE,
  payload,
});

export const updated = (payload) => ({
  type: types.UPDATED,
  payload,
});

export const navigatorOpen = (payload) => ({
  type: types.NAVIGATOR_OPEN,
  payload,
});

export const zoomed = (payload) => ({
  type: types.ZOOMED,
  payload,
});

export const tap = () => ({
  type: types.TAP,
});

export const setCurrentFlyerPages = (flyerId, pages) => ({
  type: types.SET_CURRENT_FLYER_PAGES,
  payload: {
    flyerId,
    pages,
  },
});

export const fetchPages = (_) => ({ type: types.FETCH_FLYER_PAGES });

export const setDirection = (direction) => ({
  type: types.SET_DIRECTION,
  payload: {
    direction,
  },
});

export const indexButtonClick = (flyerId) => ({
  type: types.INDEX_BUTTON_CLICK,
  payload: {
    flyerId,
  },
});
export const sectionClick = (flyerId, sectionName) => ({
  type: types.SECTION_CLICK,
  payload: {
    flyerId,
    sectionName,
  },
});

export const setViewerExtrasBase = (extrasBase) => ({
  type: types.SET_VIEWER_EXTRAS_BASE,
  payload: {
    extrasBase,
  },
});
